import Vue from "vue";
import Router from "vue-router";
import Login from "./views/Login.vue";
import About from "./views/About.vue";
// import Login from "./views/Login.vue";
import DO from "./views/Delivery_order.vue";
import PO from "./views/Purchase_order.vue";
import DO_INVOICE from "./views/Do_invoice.vue";
import PO_INVOICE from "./views/Po_invoice.vue";
import USER from "./views/Create_user.vue";
import PRODUCT from "./views/Product.vue";
import BASKET from "./views/Basket.vue";
import CN from "./views/Customer_CN.vue";



Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: '/',
      name: 'DO',
      component: DO
    },
    {
      path: '/PO',
      name: 'PO',
      component: PO
    }
    ,
    {
      path: '/CUSTOMER_INVOICE',
      name: 'DO_INVOICE',
      component: DO_INVOICE
    },
    {
      path: '/FARMER_INVOICE',
      name: 'PO_INVOICE',
      component: PO_INVOICE
    },
    {
      path: '/USER',
      name: 'USER',
      component: USER
    },
    {
      path: '/PRODUCT',
      name: 'PRODUCT',
      component: PRODUCT
    },
    {
      path: '/BASKET',
      name: 'BASKET',
      component: BASKET
    },
    {
      path: '/CN',
      name: 'CN',
      component: CN
    }



  ]
});
